__turbopack_context__.v({
  "additionalSolutions": "ModularizedPlanCard-module-scss-module__fLH9rW__additionalSolutions",
  "body": "ModularizedPlanCard-module-scss-module__fLH9rW__body",
  "checkbox": "ModularizedPlanCard-module-scss-module__fLH9rW__checkbox",
  "disabled": "ModularizedPlanCard-module-scss-module__fLH9rW__disabled",
  "featuresElement": "ModularizedPlanCard-module-scss-module__fLH9rW__featuresElement",
  "featuresList": "ModularizedPlanCard-module-scss-module__fLH9rW__featuresList",
  "line-break": "ModularizedPlanCard-module-scss-module__fLH9rW__line-break",
  "successIcon": "ModularizedPlanCard-module-scss-module__fLH9rW__successIcon",
  "text-align_center": "ModularizedPlanCard-module-scss-module__fLH9rW__text-align_center",
});
